import { Alert, Button, Form, Input, Row, Spin, Typography } from 'antd';

import {
  EMAIL_LENGTH_VALIDATION,
  EMAIL_TYPE_VALIDATION,
  ERROR_REQUIRED_FIELD,
  OFF,
  PNG,
} from '@app/constants';

import type { PasswordFormValues } from '@pages/Authorization/Authorization.types';

import type { FormInstance } from 'antd';
import type { ChangeEventHandler, FC } from 'react';

import '@pages/Authorization/ui/components/Password.scss';

interface PasswordProps {
  captchaChangeHandler: ChangeEventHandler<HTMLInputElement>;
  captchaImage: string;
  clearServerErrorHandler: () => void;
  emailChangeHandler: ChangeEventHandler<HTMLInputElement>;
  finishHandler: (values: PasswordFormValues) => Promise<void>;
  form: FormInstance<PasswordFormValues>;
  isPageLoader: boolean;
  isSubmitLoader: boolean;
  serverError: string;
}

export const Password: FC<PasswordProps> = ({
  captchaChangeHandler,
  captchaImage,
  clearServerErrorHandler,
  emailChangeHandler,
  finishHandler,
  form,
  isPageLoader,
  isSubmitLoader,
  serverError,
}) => (
  <Form
    form={form}
    className="Password"
    name="authorization-by-password"
    initialValues={{ remember: true }}
    autoComplete={OFF}
    onFinish={finishHandler}
  >
    {isPageLoader ? (
      <Row justify="center" style={{ marginBottom: '24px' }}>
        <Spin />
      </Row>
    ) : (
      <>
        <Typography className="Password__label">
          Введите адрес электронной почты
        </Typography>
        <Form.Item
          normalize={(value) => value?.trim() || ''}
          name="email"
          rules={[
            { required: true, message: ERROR_REQUIRED_FIELD },
            EMAIL_TYPE_VALIDATION,
            EMAIL_LENGTH_VALIDATION,
          ]}
        >
          <Input
            maxLength={100}
            className="Password__field"
            size="large"
            onChange={emailChangeHandler}
          />
        </Form.Item>

        <Typography className="Password__label">Пароль</Typography>
        <Form.Item name="password">
          <Input className="Password__field" type="password" size="large" />
        </Form.Item>
      </>
    )}

    {captchaImage && (
      <>
        <Typography className="Password__captcha-label">
          Защита от ботов
        </Typography>
        <div className="Password__captcha-container">
          <img
            className="Password__captchaImage"
            src={`data:${PNG};base64,${captchaImage}`}
            alt="captcha-image"
          />
          <Form.Item
            label={null}
            name="captcha"
            rules={[{ required: true, message: ERROR_REQUIRED_FIELD }]}
          >
            <Input
              className="Password__captcha-field"
              size="large"
              onChange={captchaChangeHandler}
            />
          </Form.Item>
        </div>
      </>
    )}

    {serverError && (
      <div className="Password__alert-container" data-testid="error-message">
        <Alert
          className="Password__alert"
          description={serverError}
          type="error"
          showIcon
          onClick={clearServerErrorHandler}
        />
      </div>
    )}

    <Form.Item className="Password__button-container">
      <Button
        id="test-enter-by-password-button"
        className="Password__sign-in-button"
        type="primary"
        size="large"
        htmlType="submit"
        loading={isSubmitLoader}
      >
        Войти
      </Button>
    </Form.Item>
  </Form>
);
